// change infringementTypes acronyms to
export const letterCaseFormat = (filterCategory: string, filterValue: string) => {
  if (filterCategory === 'infringementTypes') {
    switch (filterValue) {
      case 'CCO':
        return 'Cco';
      case 'CDO':
        return 'Cdo';
      default:
        return filterValue;
    }
  }
  return filterValue;
};

export const convertToFullName = details => {
  const { firstName, lastName } = details;
  const nameArray: string[] = [];

  [firstName, lastName].forEach((field: string | null) => {
    if (field) {
      nameArray.push(field.trimRight());
    }
  });

  return nameArray.join(' ');
};

export const convertToAddress = address => {
  const { streetAddress, streetAddress2, city, state, postcode } = address;
  const fieldArray = [streetAddress, streetAddress2, city, state, postcode];
  const addressArray: string[] = [];
  fieldArray.forEach((field: string | null) => {
    if (field) {
      addressArray.push(field.trimRight());
    }
  });
  return addressArray.join(', ');
};

/**
 * Converts a time string in the format of "hours:minutes" to seconds.
 *
 * @param time - The time string to convert in the format "HH:MM"
 * @returns The equivalent time in seconds (hours * 3600 + minutes * 60)
 *
 * @example
 * // Returns 3660 (1 hour and 1 minute in seconds)
 * convertTimeStringToSeconds("1:01")
 */
export const convertTimeStringToSeconds = (time: string): number => {
  // Split the time string by colon
  const [hours, minutes] = time.split(':').map(Number);
  // Convert to seconds: hours * 3600 + minutes * 60
  return hours * 3600 + minutes * 60;
};

/**
 * Converts a given number of seconds into a time string in the format "HH:MM".
 *
 * @param seconds - The number of seconds to convert
 * @returns A string representation of the time in the format "HH:MM"
 *
 * @example
 * // Returns "01:30"
 * convertSecondsToTimeString(5400);
 *
 * @example
 * // Returns "00:05"
 * convertSecondsToTimeString(300);
 */
export const convertSecondsToTimeString = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}`;
};
